import { render, staticRenderFns } from "./roteiro.vue?vue&type=template&id=5b512522"
import script from "./roteiro.vue?vue&type=script&lang=js"
export * from "./roteiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports